<template>
  <v-app id="Login">
    <v-container class="fill-height" fluid >
      <v-row align="center" justify="center" >
        <v-col cols="12" sm="8" md="4" >
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat >
              <v-toolbar-title>one-PREACT</v-toolbar-title>
            </v-toolbar>
            <v-alert transition="scale-transition"  outlined type="error" v-if="alertShow">{{alertShowMes}}</v-alert>
            <v-progress-linear absolute indeterminate color="red" v-if="processingSendForm"></v-progress-linear>
            <v-card-text>
              <v-form>
                <v-text-field
                  autofocus
                  label="Логін"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="login"
                ></v-text-field>
                <v-text-field
                  label="Пароль"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                  @keyup.enter="logInning"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click.prevent="logInning">Увійти</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
  export default {
    data: function () {
      return {
        login: '',
        password: '',
        alertShow: false,
        alertShowMes: '',
        processingSendForm: false,
      }
    },
    methods:{
      logInning(){
        this.processingSendForm = true
        this.alertShow = false
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            login: this.login,
            password: this.password,
            route: this.$route.path,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
          .then(async response => {
            const data = await response.json();
            if (!response.ok) {
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }
            this.processingSendForm = false;
            if (data.isauth == true) {
              localStorage.pp = data.pp
              localStorage.pn = data.pn
              this.$store.dispatch('LOGINNING', {isauth:data.isauth})
              this.$store.dispatch('PIPCH', {pip:data.pip})
              this.$router.push('/').catch(()=>{})
            }
            if (data.isauth == false) {
              this.alertShow = true
              this.alertShowMes = 'Хибний Логін або Пароль'
            }
            
          })
          .catch(error => {
            this.processingSendForm = false
            this.alertShow = true
            this.alertShowMes = error
            //console.error('Error!', error)
          });
          
      }
  
    },
  }
</script>